import React, { useState } from "react";
import {
  Box,
  FormLabel,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

const SummaryStep = ({ formData, filterModel, selectedIds, reduxUsers }) => {
  const {
    name,
    description,
    playlistType,
    ppsNumber,
    worksite,
    notes,
    possessionManager,
    worksiteManager,
    fatality,
    isPublic,
    selectedUsers = [],
  } = formData;

  const [showSharedUsers, setShowSharedUsers] = useState(false);

  const hasFilters = filterModel?.items?.length > 0;
  const hasIds = selectedIds?.length > 0;

  const sharedUserList =
    !isPublic && reduxUsers.filter((user) => selectedUsers.includes(user.id));

  return (
    <Box>
      <FormLabel component="legend" sx={{ mb: 2 }}>
        Summary: Review the playlist details before submission.
      </FormLabel>

      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>
              <strong>Name</strong>
            </TableCell>
            <TableCell>{name}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Description</strong>
            </TableCell>
            <TableCell>{description}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Playlist Type</strong>
            </TableCell>
            <TableCell>{playlistType}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>PPS Number</strong>
            </TableCell>
            <TableCell>{ppsNumber || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Worksite</strong>
            </TableCell>
            <TableCell>{worksite || "N/A"}</TableCell>
          </TableRow>

          {playlistType === "close_call" && (
            <TableRow>
              <TableCell>
                <strong>Notes</strong>
              </TableCell>
              <TableCell>{notes || "N/A"}</TableCell>
            </TableRow>
          )}

          {playlistType === "incident" && (
            <>
              <TableRow>
                <TableCell>
                  <strong>Possession Manager</strong>
                </TableCell>
                <TableCell>{possessionManager || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <strong>Worksite Manager</strong>
                </TableCell>
                <TableCell>{worksiteManager || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <strong>Fatality</strong>
                </TableCell>
                <TableCell>{fatality ? "Yes" : "No"}</TableCell>
              </TableRow>
            </>
          )}

          {hasFilters && (
            <TableRow>
              <TableCell>
                <strong>Filters</strong>
              </TableCell>
              <TableCell>
                {filterModel.items.map((filter, index) => (
                  <Typography variant="body2" key={index}>
                    • {filter.columnField || filter.field}{" "}
                    {filter.operatorValue || filter.operator} {filter.value}
                  </Typography>
                ))}
              </TableCell>
            </TableRow>
          )}

          {hasIds && !hasFilters && (
            <TableRow>
              <TableCell>
                <strong>Selected Call Count</strong>
              </TableCell>
              <TableCell>
                {selectedIds.length} recorded calls selected
              </TableCell>
            </TableRow>
          )}

          <TableRow>
            <TableCell>
              <strong>Shared With</strong>
            </TableCell>
            <TableCell>
              {isPublic ? (
                "Public – accessible to all users"
              ) : sharedUserList.length > 0 ? (
                <>
                  {sharedUserList.length} user(s) selected{" "}
                  <Typography
                    variant="body2"
                    sx={{
                      display: "inline",
                      color: "primary.main",
                      cursor: "pointer",
                      ml: 1,
                      textDecoration: "underline",
                    }}
                    onClick={() => setShowSharedUsers((prev) => !prev)}
                  >
                    {showSharedUsers ? "Hide" : "Show All"}
                  </Typography>
                  {showSharedUsers && (
                    <Box sx={{ maxHeight: 150, overflowY: "auto", mt: 1 }}>
                      {sharedUserList.map((user) => (
                        <Typography key={user.id} variant="body2">
                          • {user.fullName} ({user.role})
                        </Typography>
                      ))}
                    </Box>
                  )}
                </>
              ) : (
                "None selected"
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default SummaryStep;
